var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogolar02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70.87 70.87",
    style: {
      enableBackground: "new 0 0 70.87 70.87"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36.94,35.96c-0.76,1.12-0.11,2.59,0.67,3.34c0.72,0.68,1.29,0.84,1.37,0.86l0.37-0.7l1.06,2.88l-2.98,0.61l0.4-0.73 l-0.4-0.23c-1.25-0.82-1.52-1.93-1.61-2.28C35.65,39.12,35.43,37.33,36.94,35.96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.92,36.01c0.54,1.24,2.13,1.48,3.19,1.21c0.93-0.24,1.37-0.62,1.45-0.69l0-0.01l-0.4-0.69l3,0.66l-1.09,2.84l-0.4-0.72 l-0.39,0.21c-1.36,0.63-2.44,0.26-2.78,0.14C38.91,38.79,37.28,38.02,36.92,36.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.23,33.02c-0.21,1.48-1.1,2.2-1.38,2.42c-0.48,0.39-2,1.35-3.88,0.56c1.34,0.21,2.4-0.99,2.74-2.02 c0.31-0.92,0.22-1.51,0.2-1.6l-0.01,0l-0.8-0.04l2.17-2.18l1.81,2.45l-0.82-0.05L42.23,33.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.13,31.76c-0.68,0-1.24-0.55-1.24-1.24c0-0.68,0.55-1.24,1.24-1.24c0.68,0,1.24,0.56,1.24,1.24 C34.37,31.21,33.81,31.76,33.13,31.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.21,37.79c0.11-0.29,0.26-0.27,0.26-0.27s0.14-0.03,0.22,0.26l1.16,4.07c-0.97-0.28-1.85-0.76-2.59-1.39L31.21,37.79z  M34.82,26.93c-4.47,0-8.11,3.64-8.11,8.11c0,4.47,3.64,8.11,8.11,8.11c0.24,0,0.47-0.01,0.71-0.03l0.05,0.81l1.48-1.44l-1.66-1.27 l0.06,0.86c-0.21,0.02-0.43,0.03-0.65,0.03c-0.34,0-0.68-0.03-1.01-0.07l-0.03-0.22l-0.77-6.57c-0.11-1.24,0.6-1.44,1.04-1.25 L36.51,35c0.28,0.12,0.42-0.12,0.42-0.12s0.16-0.25-0.12-0.43c0,0-3.35-2.22-4.07-2.36c-0.97-0.18-1.94,0.61-2.15,1.64l-1.19,5.83 c-1.02-1.23-1.64-2.81-1.64-4.53c0-3.9,3.18-7.08,7.08-7.08c2.08,0,3.96,0.91,5.26,2.35l0.73-0.74 C39.33,27.95,37.19,26.93,34.82,26.93"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogolar02);
export default __webpack_public_path__ + "static/media/logolar-02.b2cd2c411466387d58927f6e26d1217b.svg";
export { ForwardRef as ReactComponent };